import httpClient from '../utils/httpClient';

export const insertInquiry = async (requestParams) => {
    const response = await httpClient.post('/inquiry/create-inquiry', requestParams);
    return response.data;
};